<template lang="pug">
form(@submit.prevent='onConfirm')
  modal(
    active
    @close='$router.back()',
    :title='`Ciência no Documento (${current.numero}/${current.ano})`'
  )
    div(slot="modal-body")
      .columns
        .column.col-12
          form-group(
            :label='"doc_ciencia.tipo" | tModel',
            :validation='$v.ciencia.tipo'
          )
            select.form-select(v-model='$v.ciencia.tipo.$model')
              option(v-for='(label, value) in tipos', :value='value') {{ label }}
        .column.col-12
          form-group(
            :label="'doc_ciencia.ciencia_em' | tModel",
            :validation='$v.ciencia.ciencia_em'
          )
            datepicker(v-model='$v.ciencia.ciencia_em.$model' type="datetime" format='DD/MM/YYYY HH:mm')
      .divider.text-center(v-if="ciencia.tipo" data-content="Assinatura")
      .columns(v-if="ciencia.tipo === 'pessoal'")
        .column.col-4
          form-group(:validation="$v.cpfCnpj" label="CPF/CNPJ")
            input-cpf-cnpj.form-input(v-model="$v.cpfCnpj.$model" masked @input="mountAssinatura")
        .column.col-8
          form-group(:validation="$v.nome" label="Nome")
            input.form-input(v-model="$v.nome.$model" @input="mountAssinatura")
        .column.col-12.mt-2(v-if="ciencia.assinatura")
          span {{ 'doc_ciencia.assinatura' | tModel }}: #[cite.text-bold {{ ciencia.assinatura }}]
      .columns(v-else-if="ciencia.tipo")
        .column.col-12
          form-group(:validation="$v.ciencia.assinatura" :label="labelAssinatura")
            input.form-input(v-model="$v.ciencia.assinatura.$model")
      div
        form-group(label='Descrição/Observações (opcional)' :validation='$v.ciencia.descricao')
          input.form-input(v-model='$v.ciencia.descricao.$model')
    div(slot='modal-footer')
      button.btn.btn-primary(
        :disabled='$v.ciencia.$invalid || loading',
        :class='{ loading }'
      )
        btn-content(name='confirm')
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import cpfCnpjValidator from '@/lib/validators/cpfCnpj'
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'fiscalizacao/docs': {
      state: ['current'],
      actions: ['fetchCiencia'],
    },
  },
  computed: {
    tipos() {
      return {
        pessoal: 'Pessoalmente',
        correios: 'Correios', // AR e identificação do recebedor
        diario_oficial: 'Orgão Oficial', // numero e data do orgão
        protocolo: 'Protocolo', // numero e data do protocolo
        correcao: 'Correção', // correção de ciência anterior
      }
    },
    labelAssinatura() {
      switch (this.ciencia.tipo) {
        case 'correios':
          return 'AR e identificação do recebedor'
        case 'diario_oficial':
          return 'Número e data do orgão'
        case 'protocolo':
          return 'Protocolo (tipo número/ano data)'
        case 'correcao':
          return 'Assinatura (nº do documento/nome)'
        default:
          return 'Assinatura'
      }
    },
  },
  data() {
    return {
      ciencia: {
        tipo: 'pessoal',
        descricao: '',
        assinatura: '',
        ciencia_em: '',
      },
      cpfCnpj: '',
      nome: '',
      loading: false,
    }
  },
  methods: {
    mountAssinatura() {
      this.ciencia.assinatura = `${this.cpfCnpj} ${this.nome}`
    },
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        const params = { id, ciencia: this.ciencia }
        await this.fetchCiencia(params)
        this.$toaster.success('Ciência realizada com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
  validations: {
    ciencia: {
      tipo: { required },
      descricao: { maxLength: maxLength(255) },
      assinatura: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(255),
      },
      ciencia_em: { required },
    },
    cpfCnpj: { required, cpfCnpjValidator },
    nome: { required },
  },
}
</script>
